import { AllHtmlEntities } from 'html-entities';

export const entities = new AllHtmlEntities();
